// extracted by mini-css-extract-plugin
export default {"adminUpdate":"AdminUpdate_adminUpdate__VwSuO","form":"AdminUpdate_form__P9GC5"};